import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";

// Guest Pages
import GuestHome from "@/pages/guest/GuestHome";
import GuestCheckin from "@/pages/guest/GuestCheckin";
import ExperiencesList from "@/pages/guest/ExperiencesList";
import FoodMenu from "@/pages/guest/FoodMenu";
import Cart from "@/pages/guest/Cart";
import Requests from "@/pages/guest/Requests";
import LandingPage from "@/pages/guest/LandingPage";

// Staff Pages
import StaffLogin from "@/pages/staff/StaffLogin";
import StaffDashboard from "@/pages/staff/StaffDashboard";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminExperiences from "@/pages/admin/AdminExperiences";
import AdminMenu from "@/pages/admin/AdminMenu";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminLogs from "@/pages/admin/AdminLogs";
import AdminAuditTrail from "@/pages/admin/AdminAuditTrail";
import AdminProperties from "@/pages/admin/AdminProperties";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminPropertyInfo from "@/pages/admin/AdminPropertyInfo";
import AdminQRCodes from "@/pages/admin/AdminQRCodes";
import AdminCategorySettings from "@/pages/admin/AdminCategorySettings";
import AdminReports from "@/pages/admin/AdminReports";
import AdminMessageTemplates from "@/pages/admin/AdminMessageTemplates";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminVendors from "@/pages/admin/AdminVendors";
import { AdminBroadcast } from "@/pages/admin/AdminBroadcast";

// Shared Pages
import ForgotPassword from "@/pages/ForgotPassword";
import ImpersonationBanner from "@/components/ImpersonationBanner";

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <BrowserRouter>
          <ImpersonationBanner />
          <Routes>
            {/* Check-in Routes - must be before property routes */}
            <Route path="/:slug/checkin" element={<GuestCheckin />} />
            
            {/* Guest Routes */}
            <Route path="/" element={<LandingPage />} />
            
            {/* Guest sub-pages (use ?property= query param) */}
            <Route path="/experiences" element={<ExperiencesList />} />
            <Route path="/food" element={<FoodMenu />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/requests" element={<Requests />} />
            
            {/* Team / Staff Routes */}
            <Route path="/team/login" element={<StaffLogin />} />
            <Route path="/team/dashboard" element={<StaffDashboard />} />
            <Route path="/staff/login" element={<StaffLogin />} />
            <Route path="/staff/dashboard" element={<StaffDashboard />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/properties" element={<AdminProperties />} />
        <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/experiences" element={<AdminExperiences />} />
            <Route path="/admin/menu" element={<AdminMenu />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/logs" element={<AdminLogs />} />
            <Route path="/admin/audit-trail" element={<AdminAuditTrail />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/property-info" element={<AdminPropertyInfo />} />
            <Route path="/admin/qr-codes" element={<AdminQRCodes />} />
            <Route path="/admin/category-settings" element={<AdminCategorySettings />} />
            <Route path="/admin/reports" element={<AdminReports />} />
            <Route path="/admin/message-templates" element={<AdminMessageTemplates />} />
            <Route path="/admin/broadcast" element={<AdminBroadcast />} />
            <Route path="/admin/coupons" element={<AdminCoupons />} />
            <Route path="/admin/vendors" element={<AdminVendors />} />
            
            {/* Shared Routes */}
            <Route path="/forgot-password" element={<ForgotPassword />} />
            
            {/* Dynamic property slug route — catches /VaranasiHostel, /darjeeling-hostel, etc. */}
            <Route path="/:propertySlug" element={<GuestHome />} />
            
            {/* 404 Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </ErrorBoundary>
  );
}

export default App;
